import * as React from 'react';

// HORO-10326: chevron-down glyph per Figma 1060:12877 — used as the
// collapsed-sidebar "view all" affordance (V-shape pointing down,
// expand toward catalogue).
const ChevronDownIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={17} height={17} viewBox="0 0 17 17" fill="none" {...props}>
        <path stroke="#FFFFFF" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" d="m4 6 4.5 4.5L13 6" />
    </svg>
);

export default ChevronDownIcon;
